import { FunctionComponent, useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSnapshot } from 'valtio';
import { resetRepoSelectionStore } from '../../onboarding/store-actions/repo-selection-store-actions';
import { closeConnectorConfigureModal } from '../actions/connector-configure-actions';
import { setInitialFormValues } from '../actions/connector-configure-form-actions';
import { dismissSingleValidationMsg } from '../actions/credentials-actions';
import ConnectorConfigureModal from '../components/ConnectorConfigureModal';
import { resetFormInputs } from '../store-actions/connector-config-form-store-action';
import ConnectorConfigureStore from '../stores/connector-configure-store';
import ConnectorConfigureFormContainer from './ConnectorConfigureFormContainer';
import ConnectorRepoSelectionContainer from './ConnectorRepoSelectionContainer';

const ConnectorConfigureContainer: FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    isModalVisible,
    originalConnector,
    selectedConnector,
    isSourceControlFamilyConnector,
  } = useSnapshot(ConnectorConfigureStore);

  useEffect(() => {
    return () => {
      dismissSingleValidationMsg();
      resetRepoSelectionStore();
    };
  });

  useEffect(() => {
    setInitialFormValues();

    return () => {
      resetFormInputs();
    };
  }, [selectedConnector, originalConnector]);

  const handleCloseModal = useCallback(() => {
    closeConnectorConfigureModal();

    // Clear the search params but preserve the 'search' state
    const search = searchParams.get('search');
    setSearchParams(search ? { search } : {});
  }, [setSearchParams, searchParams]);

  if (!originalConnector) return null;
  let modalHeader = `Configure your ${originalConnector.displayName} credentials`;
  if (originalConnector.isOxBuiltIn && !originalConnector.comingSoon) {
    modalHeader = `${originalConnector.displayName} connector status`;
  } else if (originalConnector.comingSoon) {
    modalHeader = `${originalConnector.displayName} - Coming Soon!`;
  }
  return (
    <>
      <ConnectorConfigureModal
        open={isModalVisible}
        modalHeader={modalHeader}
        onClose={handleCloseModal}>
        <ConnectorConfigureFormContainer />
      </ConnectorConfigureModal>
      {selectedConnector &&
        isSourceControlFamilyConnector &&
        selectedConnector.isConfigured && <ConnectorRepoSelectionContainer />}
    </>
  );
};

export default ConnectorConfigureContainer;
